import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react'

import i18n from '@batical/i18n'
import { useContextValue } from '@batical/reducer/src'
import { CalculCodeStateKeys } from '@batical/types/src'

import { ViewLine, CalculText, CalculTextInput } from './LineStyleComponent'
import TextInputAdornment from './TextInputAdornment'

export type PressionLineProps = {
  calculCode: CalculCodeStateKeys
  /**
   * Unit value to display
   *
   * @type {string}
   */
  unit?: string
  onChange?: (number: number, value: string) => void
  variableName: string
  icon: unknown
  /**
   * if true, the line is the first of a group
   *
   * @type {boolean}
   */
  first?: boolean
  /**
   * if true, the line is the last of a group
   *
   * @type {boolean}
   */
  last?: boolean
  /**
   * If true, the calcul will be done
   *
   * @type {boolean}
   */
  doCalcul?: boolean
  onPressionMap?: () => void
}
const isDouble = (value: unknown) => {
  return typeof value === 'number' || value instanceof Number
}

const PressionLine = ({ calculCode, variableName, unit, onChange, first, last, doCalcul = false }: PressionLineProps) => {
  const [value, update] = useContextValue(variableName, calculCode, doCalcul)

  const textInputRef = useRef(null)
  const [inputVal, setInputVal] = useState('0')

  const text = useMemo(() => {
    let t = i18n.t(`${calculCode}_${variableName}`)

    return t
  }, [calculCode, variableName])

  useEffect(() => {
    if (isDouble(value)) {
      setInputVal(String(+value))
    }
  }, [value])

  const _onEndEditing = useCallback(() => {
    const result = parseFloat(inputVal.replace(',', '.'))
    if (isNaN(result)) {
      setInputVal(String(+value))

      if (onChange) {
        onChange(0, variableName)
      } else {
        update(0)
      }
    } else if (String(value) === inputVal) {
      // console.error('textinputline, I donw now why this condition but should not happen')
      // i saw it happen so it is required but did not analyse why
      if (onChange) {
        onChange(value, variableName)
      } else {
        update(value)
      }

      setInputVal(inputVal)
    } else {
      if (onChange) {
        onChange(result, variableName)
      } else {
        update(result)
      }
    }
  }, [inputVal, onChange, update, value, variableName])

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const _onChangeText = useCallback((event: any) => {
    setInputVal(event.target.value)
  }, [])

  const onFocus = useCallback(() => {
    setInputVal('')
  }, [])

  // const _onTouchCell = useCallback(() => {
  //   if (onDisclosurePress != null) {
  //     let val = 0 || parseFloat(inputVal.replace(',', '.'))
  //     // if (value != null) {
  //     onDisclosurePress(val, extraParam)
  //     //  }
  //   } else {
  //     //textInputRef?.current?.focus()
  //   }
  // }, [extraParam, inputVal, onDisclosurePress])
  const onKeypress = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e: any) => {
      if (e.key === 'Enter') {
        _onEndEditing()
      }
    },
    [_onEndEditing]
  )
  return (
    <ViewLine first={first} last={last}>
      <CalculText>{text}</CalculText>
      <CalculTextInput
        ref={textInputRef}
        value={inputVal}
        onFocus={onFocus}
        onChange={_onChangeText}
        onKeyPress={onKeypress}
        onBlur={_onEndEditing}
        variant="outlined"
        size="small"
        // @ts-ignore
        InputProps={{
          endAdornment: <TextInputAdornment text={unit} />
        }}
      />
    </ViewLine>
  )
}

export default memo(PressionLine)
